/**
 * Created with IntelliJ IDEA.
 * User: noam
 * Date: 1/14/14
 * Time: 5:33 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var Button = require("ui/button/Button");
    var Paging = require("ui/paging/Paging");
    var template = require("content-templates/content-edit/system/contentSystemEditLayout.tmpl");
    var DropdownMenu = require("ui/dropdown-menu/DropdownMenu");


    var ContentSystemEditLayout = {};
    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentSystemEditLayout = Marionette.Layout.extend({
            template: template,
            className: "content-edit",
            regions: {
                dialogContainerRegion: ".dialog-container",
                leftPane: ".left-pane"
            },
            events: {
                "click .closeBtn": "_cancel"
            },
            ui: {
                footerContainer:  ".page-footer",
                pagingContainer:  ".paging-container",
                mainArea:         ".view-container",
                cancelButton:     ".button-cancel"
            },
            uiComponents: {
                cancelBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton"
                    },
                    events: {
                        "click": "_cancel"
                    }
                },
                paging: {
                    type: Paging,
                    options: {
                        el: "view.ui.pagingContainer",
                        blockWrongPageNumber: true,
                        pageType: Paging.PAGE_TYPE.ITEM
                    },
                    events: {
                        "change:page": "_changePage"
                    }
                }
            },

            initialize: function (options) {
                LEContent.logger.debug("initialize ContentSystemEditLayout", "ContentSystemEditLayout:initialize");
                this.channel = options.channel;
                this.listenTo(this.model,"change:model",this._onModelChanged);
                this.listenTo(this.model,"change:pageInfo.*",this._updatePagingComponent);
            },
            onRender: function () {
                LEContent.logger.debug("onRender ContentSystemEditLayout", "ContentSystemEditLayout:onRender");
                this.listenTo(this, "page:closeButtonClick", this._closeWindowButtonClicked);
                this._onModelChanged();
            },
            _getActionsCollection: function() {
                return new DropdownMenu.Collection([
                    {
                        id:"restoreToDefaults",
                        "actionName":LE.translator.translate("LEContent.content.edit.editor.restore.defaults.confirm.button"),
                        "title": LE.translator.translate("LEContent.content.edit.editor.restore.defaults.tooltip"),
                        "align": "right",
                        "enabled":true
                    }
                ]);
            },
            _onModelChanged: function () {
                //move back the scroller of the page to top
                this.ui.mainArea.scrollTop(0);
            },
            _updatePagingComponent: function(){
                this.uiComponents.paging.setInfo(this.model.getContentPageInfoCurrentPage()+1,this.model.getContentPageInfoTotal());
            },

            _cancel: function () {
                LEContent.logger.info("User clicked on 'Cancel' button.", "ContentSystemEditLayout::_cancel");
                this.channel.trigger("contentSystemEditLayout:cancel");
            },
            _closeWindowButtonClicked: function () {
                LEContent.logger.info("User clicked on 'close' button.", "ContentSystemEditLayout::_closeWindowButtonClicked");
                this.channel.trigger("contentSystemEditLayout:closeWindow");
            },

            _changePage: function (component,event,idx) {
                idx = idx -1; //update idx to use correct array indexing
                LEContent.logger.info("User asks to change page to " + idx, "ContentSystemEditLayout::_changePage");
                this.channel.trigger("contentSystemEditLayout:changePage",idx);
            },

            onClose: function () {
                LEContent.logger.debug("content layout onClose", "ContentSystemEditLayout::onClose");
            },

            //check for view errors in the inner components
            validateView: function() {
                if (_.isFunction(this.leftPane.currentView.validateView)) {
                    return this.leftPane.currentView.validateView();
                }
                else{
                    return 0;
                }
            }
        });

    });
    return ContentSystemEditLayout;
});
